export const red = {
    30: "#FDF3F2",
    35: "#F7DCDA",
    40: "#FDB4B4",
    50: "#F36262",
    60: "#EB4C4C",
    70: "#F3122F",
    80: "#D0152D",
    90: "#9D0115",
    100: "#6A010E",
};
